import { hideElement, showElement } from "@grindex-common/helpers/domManipulation";
import { screwButtonsSettings } from "@grindex-common/helpers/constants";

function createElement(type, elementClasses) {
	const element = document.createElement(type);

	if (elementClasses) {
		if (Array.isArray(elementClasses)) {
			elementClasses.forEach((cssClass) => {
				element.classList.add(cssClass);
			});
		} else {
			element.classList.add(elementClasses);
		}
	}

	return element;
}

class LocationFacets {
	constructor($module, $clearFacetsBtn) {
		this.$module = $module;
		this.$clearFacetsBtn = $clearFacetsBtn;
	}

	renderFacets(facetGroups, $facetsContainer, searchCallback) {
		$facetsContainer.innerHTML = "";

		if (!facetGroups) {
			hideElement($facetsContainer.querySelector(".hidden-if-no-facets"));
			return;
		}

		const selectedCheckboxes = [];

		facetGroups.forEach((group) => {
			const $groupContainer = createElement("div", "facet-group-container");
			const $headingContainer = createElement("div", ["facet", group.Heading]);
			const $headingTextElement = createElement("div", ["facet-group", "facet-group-header"]);
			const $headingText = createElement("strong");
			const $facetsWrapper = createElement("div", "group");

			$headingText.innerText = group.Heading;
			$headingTextElement.appendChild($headingText);
			$headingContainer.appendChild($headingTextElement);
			$groupContainer.appendChild($headingContainer);
			$groupContainer.appendChild($facetsWrapper);

			group.Facets.forEach((facet) => {
				const $facetContainer = createElement("div", ["facets", "no-child-facet"]);
				const $checkbox = createElement("div");
				const $cbLabel = createElement("label");
				const $cbInput = createElement("input");

				if (facet.Selected === true) {
					selectedCheckboxes.push($checkbox);
					$cbInput.checked = true;
				}

				$cbInput.type = "checkbox";

				$cbLabel.innerText = `${facet.Text} (${facet.Total})`;

				$checkbox.dataset.name = facet.Text;
				$checkbox.dataset.id = facet.Value;
				$checkbox.dataset.group = group.Heading;

				$checkbox.appendChild($cbInput);

				$facetContainer.appendChild($checkbox);
				$facetContainer.appendChild($cbLabel);
				$facetsWrapper.appendChild($facetContainer);
				$headingContainer.appendChild($facetsWrapper);

				$checkbox.addEventListener("click", searchCallback);
			});

			$facetsContainer.appendChild($groupContainer);
		});

		showElement($facetsContainer.querySelector(".hidden-if-no-facets"));

		$(this.$module).find(".facet-container").find("input:checkbox").screwDefaultButtons(screwButtonsSettings(true));

		selectedCheckboxes.forEach((cb) => {
			cb.firstElementChild.setAttribute("aria-checked", true);
		});

		if (selectedCheckboxes.length === 0) {
			this.$clearFacetsBtn.classList.add("disabled");
		} else {
			this.$clearFacetsBtn.classList.remove("disabled");
		}
	}

	hideFacets($facetsContainer) {
		hideElement($facetsContainer.closest(".facet-container"));
	}

	clearFacets() {
		this.$module.querySelectorAll("input[type='checkbox']").forEach((cb) => {
			cb.checked = false;
			cb.parentElement.setAttribute("aria-checked", "false");
		});
	}

	getFacets(groupName) {
		const $checkBoxes = document.getElementsByClassName("styledCheckbox");
		const facets = [];

		$checkBoxes.forEach((cb) => {
			const dataParent = cb.parentElement;

			if (dataParent.dataset.group === groupName && cb.getAttribute("aria-checked") === "true") {
				facets.push(dataParent.dataset.id);
			}
		});

		return facets.length > 0 ? facets : null;
	}
}

export { LocationFacets };
